export * from './tooltip';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/tooltip/index.js
// module id = 471
// module chunks = 8